import Dashboard from "../layouts/Dashboard/Dashboard";
import SinglePage from "../layouts/SinglePage/SinglePage";
import PublicPage from "../layouts/PublicPage/PublicPage";

import TimelineStartup from 'views/Timeline/TimelineStartup';
import TimelineList from 'views/Timeline/TimelineList';
import TimelineActions from "views/Timeline/TimelineActions";
import TimelineHistory from "views/Timeline/TimelineHistory";
import TimelinePublications from "views/Timeline/TimelinePublications";
import TimelineQuestions from "views/Timeline/TimelineQuestions";
import TimelineHighlights from "views/Timeline/TimelineHighlights";
import TimelineFollowing from "views/Timeline/TimelineFollowing";
import TimelineCourses from "views/Timeline/TimelineCourses";

import ServerNotAvailable from "views/Public/ServerNotAvailable";
import LoginPage from 'views/Public/LoginPage';
import ForgotPassword from 'views/Public/ForgotPassword';
import ResetPassword from "views/Public/ResetPassword";
import AccountConfirmation from "views/Public/AccountConfirmation";
import Register from "views/Public/Register";

import CourseViewer from 'views/Publication/CourseViewer';
import ListViewer from "views/Publication/ListViewer";
import PollViewer from 'views/Publication/PollViewer';
import PostViewer from 'views/Publication/PostViewer';
import QuestionViewer from 'views/Publication/QuestionViewer';
import UserProfileViewer from "views/User/UserProfileViewer";
import GroupProfileViewer from "views/Group/GroupProfileViewer";

import TopicViewer from "views/Topic/TopicViewer";
import AccountEdit from "views/User/AccountEdit";

import GroupAdminList from "views/Group/GroupAdminList";
import KnowledgeTestTopicList from "views/KnowledgeTest/KnowledgeTestTopicList";
import KnowledgeTestAdminList from "views/KnowledgeTest/KnowledgeTestAdminList";
import CourseAdminList from "views/Publication/CourseAdminList";
import PublicationAdminList from "views/Publication/PublicationAdminList";
import TopicAdminList from "views/Topic/TopicAdminList";
import TopicFollowList from "views/Topic/TopicFollowList";
import UserAdminList from "views/User/UserAdminList";
import SetupMain from "views/System/SetupMain";
import GamificationSetup from "views/Gamification/GamificationSetup";

import FullGlobalSearch from "views/Search/FullGlobalSearch";
import FullUserSearch from "views/Search/FullUserSearch";
import FullTopicSearch from "views/Search/FullTopicSearch";
import FullCourseSearch from "views/Search/FullCourseSearch";
import FullDocumentSearch from "views/Search/FullDocumentSearch";

import TimelineTopic from "views/Timeline/TimelineTopic";
import AccessDenied from "views/Public/AccessDenied";
import PublicationQrCode from "views/Publication/PublicationQrCode";
import UserEvolutionDashboard, { UserEvolutionDashboardProps, UserEvolutionDashboardTabOptions } from "views/Dashboards/UserEvolutionDashboard";
import UserAndGroupsDashboard from "views/Dashboards/UserAndGroupsDashboard";
import UserAndGroupsTeamDashboard from "views/Dashboards/UserAndGroupsTeamDashboard";
import AwardsAndCreditsDashboard from "views/Dashboards/AwardsAndCreditsDashboard";
import PublicationAnalysisDashboard from "views/Dashboards/PublicationAnalysisDashboard";
import CourseAnalysisDashboard from "views/Dashboards/CourseAnalysisDashboard";
import AwardAnalysisDashboard from "views/Dashboards/AwardAnalysisDashboard";
import KnowledgeTestDashboard from "views/Dashboards/KnowledgeTestDashboard";
import KnowledgeTestAnalysisDashboard from "views/Dashboards/KnowledgeTestAnalysisDashboard";
import ConsumptionAnalysisDashboard from "views/Dashboards/ConsumptionAnalysisDashboard";

import QuizSelection from "views/Quiz/QuizSelection";
import QuizExecute from "views/Quiz/QuizExecute";
import MobilePage from "layouts/MobilePage/MobilePage";
import MobileEditor from "views/Mobile/MobileEditor";
import ReleaseNotes from "views/Public/ReleaseNotes";
import SystemLog from "views/System/SystemLog";

export interface IRoute {
    component: any;
    layout: any;
    path?: string;
    exact?: boolean;
    public?: boolean;
    fullView?: boolean;
    componentProps?: any;
    redirect?: string;
}

export class RoutePaths {
    static readonly Dashboard = "/Dashboard";

    static readonly TimelinePrefix = RoutePaths.Dashboard + "/Feeds";
    static readonly TimelineStartup = RoutePaths.TimelinePrefix + "/startup";
    static readonly TimelineActions = RoutePaths.TimelinePrefix + "/actions";
    static readonly TimelineHistory = RoutePaths.TimelinePrefix + "/history";
    static readonly TimelinePublications = RoutePaths.TimelinePrefix + "/publications";
    static readonly TimelineFollowing = RoutePaths.TimelinePrefix + "/following";
    static readonly TimelineQuestions = RoutePaths.TimelinePrefix + "/questions";
    static readonly TimelineHighlights = RoutePaths.TimelinePrefix + "/hightlights";
    static readonly TimelineCourses = RoutePaths.TimelinePrefix + "/courses";
    static readonly TimelineList = RoutePaths.TimelinePrefix + "/list/:id";
    static readonly TimelineTopic = RoutePaths.TimelinePrefix + "/topic/:id";
    static readonly FullGlobalSearch = RoutePaths.TimelinePrefix + "/fullsearch";
    static readonly FullUserSearch = RoutePaths.TimelinePrefix + "/fullUserSearch";
    static readonly FullSpecialistSearch = RoutePaths.TimelinePrefix + "/fullSpecialistSearch";
    static readonly FullTopicSearch = RoutePaths.TimelinePrefix + "/fullTopicSearch";
    static readonly FullCourseSearch = RoutePaths.TimelinePrefix + "/fullCourseSearch";
    static readonly FullDocumentSearch = RoutePaths.TimelinePrefix + "/FullDocumentSearch";

    static readonly ConfigPrefix = RoutePaths.Dashboard + "/Config";
    static readonly TopicAdminList = RoutePaths.ConfigPrefix + "/TopicAdminList/:id?";
    static readonly PublicationAdminList = RoutePaths.ConfigPrefix + "/PublicationAdminList";
    static readonly KnowledgeTestTopicList = RoutePaths.ConfigPrefix + "/KnowledgeTestTopics";
    static readonly KnowledgeTestAdminList = RoutePaths.ConfigPrefix + "/KnowledgeTestTopics/Tests";
    static readonly CourseAdminList = RoutePaths.ConfigPrefix + "/CourseAdminList";
    static readonly UserAdminList = RoutePaths.ConfigPrefix + "/UserAdminList/:id?";
    static readonly GroupAdminList = RoutePaths.ConfigPrefix + "/GroupAdminList/:id?";
    static readonly SetupMain = RoutePaths.ConfigPrefix + "/SetupMain";
    static readonly GamificationSetup = RoutePaths.ConfigPrefix + "/Gamification";
    static readonly SystemLog = RoutePaths.ConfigPrefix + "/SystemLog";

    static readonly QuizSelection = RoutePaths.Dashboard + "/QuizSelection";
    static readonly QuizExecute = RoutePaths.Dashboard + "/QuizExecute/:id";
    static readonly QuizSelectionHighlight = RoutePaths.Dashboard + "/QuizSelection?thl=:id";

    static readonly AwardsAndCreditsDashboard = RoutePaths.Dashboard + "/AwardsAndCreditsDashboard";
    static readonly UserEvolutionDashboard = RoutePaths.Dashboard + "/UserEvolution";
    static readonly UserEvolutionDashboard$Knowledge = RoutePaths.Dashboard + "/UserEvolution@Knowledge";

    static readonly UserAndGroupsDashboard = RoutePaths.Dashboard + "/UserAndGroups";
    static readonly UserAndGroupsTeamDashboard = RoutePaths.Dashboard + "/UserAndGroupsTeam";
    static readonly PublicationAnalysisDashboard = RoutePaths.Dashboard + "/PublicationAnalysis";
    static readonly CourseAnalysisDashboard = RoutePaths.Dashboard + "/CourseAnalysis";
    static readonly AwardAnalysisDashboard = RoutePaths.Dashboard + "/AwardAnalysis";
    static readonly KnowledgeTestAnalysisDashboard = RoutePaths.Dashboard + "/KnowledgeTestAnalysis";
    static readonly KnowledgeTestDashboard = RoutePaths.Dashboard + "/KnowledgeTest";
    static readonly ConsumptionAnalysisDashboard = RoutePaths.Dashboard + "/ConsumptionAnalysis";

    static readonly Login = "/login";
    static readonly LoginExpired = "/login?expired=1";
    static readonly LoginNotAgree= "/login?agree=1";
    static readonly Register = "/register";
    static readonly ForgotPassword = "/forgotPassword";
    static readonly ResetPassword = "/resetPassword/:key";
    static readonly EditUserAccount = "/account/edit";
    static readonly ServerNotAvailable = "/serverNotAvailable";
    static readonly AccessDenied = "/AccessDenied";
    static readonly AccountConfirmation = "/AccountConfirmation/:key";
    static readonly ReleaseNotes = "/ReleaseNotes";

    static readonly FeedDetail = "/feed/detail";
    static readonly FeedLater = "/feed/later";
    static readonly PublicationCourseViewer = "/publication/CourseViewer/:id";
    static readonly PublicationListViewer = "/publication/ListViewer/:id";
    static readonly PublicationPollViewer = "/publication/PollViewer/:id";
    static readonly PublicationPostViewer = "/publication/PostViewer/:id";
    static readonly PublicationQuestionViewer = "/publication/QuestionViewer/:id/:aid?";
    static readonly PublicationQrCode = "/publication/qrcode/:id";
    static readonly TopicViewer = "/topic/TopicViewer/:id";
    static readonly TopicFollowList = RoutePaths.Dashboard + "/topic/TopicFollowList";

    static readonly UserProfileViewer = "/user/Profile/:id?";
    static readonly GroupProfileViewer = "/group/Profile/:id";

    static readonly MobileEditor = "/mobile/editor";
}

export const RouteList: IRoute[] = [
    { path: RoutePaths.ServerNotAvailable, component: ServerNotAvailable, layout: null, exact: true, public: true },

    { path: RoutePaths.AccessDenied, component: AccessDenied, layout: PublicPage, exact: true, public: true },
    { path: RoutePaths.Login, component: LoginPage, layout: PublicPage, exact: true, public: true, fullView: true },
    { path: RoutePaths.Register, component: Register, layout: PublicPage, exact: true, public: true, fullView: true },
    { path: RoutePaths.ForgotPassword, component: ForgotPassword, layout: PublicPage, exact: true, public: true, fullView: true },
    { path: RoutePaths.ResetPassword, component: ResetPassword, layout: PublicPage, exact: true, public: true, fullView: true },
    { path: RoutePaths.AccountConfirmation, component: AccountConfirmation, layout: PublicPage, exact: true, public: true, fullView: true },
    { path: RoutePaths.EditUserAccount, component: AccountEdit, layout: SinglePage, exact: true, public: false, fullView: true },
    { path: RoutePaths.ReleaseNotes, component: ReleaseNotes, layout: SinglePage, exact: true, public: false, fullView: true },

    { path: RoutePaths.PublicationCourseViewer, component: CourseViewer, layout: SinglePage, exact: true, public: false },
    { path: RoutePaths.PublicationListViewer, component: ListViewer, layout: SinglePage, exact: true, public: false },
    { path: RoutePaths.PublicationPollViewer, component: PollViewer, layout: SinglePage, exact: true, public: false },
    { path: RoutePaths.PublicationPostViewer, component: PostViewer, layout: SinglePage, exact: true, public: false },
    { path: RoutePaths.PublicationQuestionViewer, component: QuestionViewer, layout: SinglePage, exact: true, public: false },
    { path: RoutePaths.PublicationQrCode, component: PublicationQrCode, layout: SinglePage, exact: true, public: false },

    { path: RoutePaths.TopicViewer, component: TopicViewer, layout: SinglePage, exact: true, public: false },
    { path: RoutePaths.UserProfileViewer, component: UserProfileViewer, layout: SinglePage, exact: false, public: false },
    { path: RoutePaths.GroupProfileViewer, component: GroupProfileViewer, layout: SinglePage, exact: false, public: false },

    { path: RoutePaths.MobileEditor, component: MobileEditor, layout: MobilePage, exact: false, public: false },

    { path: RoutePaths.Dashboard, component: Dashboard, layout: null, exact: false, public: false },
];

export const RouteDashboard: IRoute[] = [
    { path: RoutePaths.TimelineStartup, component: TimelineStartup, layout: Dashboard, exact: true, public: false },
    { path: RoutePaths.TimelineList, component: TimelineList, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.TimelineActions, component: TimelineActions, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.TimelineHistory, component: TimelineHistory, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.TimelinePublications, component: TimelinePublications, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.TimelineCourses, component: TimelineCourses, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.TimelineQuestions, component: TimelineQuestions, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.TimelineHighlights, component: TimelineHighlights, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.TimelineFollowing, component: TimelineFollowing, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.TimelineTopic, component: TimelineTopic, layout: Dashboard, exact: false, public: false },

    { path: RoutePaths.AwardsAndCreditsDashboard, component: AwardsAndCreditsDashboard, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.UserEvolutionDashboard, component: UserEvolutionDashboard, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.UserEvolutionDashboard$Knowledge, component: UserEvolutionDashboard, layout: Dashboard, exact: false, public: false, componentProps: { tab: UserEvolutionDashboardTabOptions.Knowledge } as UserEvolutionDashboardProps },
    { path: RoutePaths.UserAndGroupsDashboard, component: UserAndGroupsDashboard, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.UserAndGroupsTeamDashboard, component: UserAndGroupsTeamDashboard, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.PublicationAnalysisDashboard, component: PublicationAnalysisDashboard, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.CourseAnalysisDashboard, component: CourseAnalysisDashboard, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.AwardAnalysisDashboard, component: AwardAnalysisDashboard, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.KnowledgeTestAnalysisDashboard, component: KnowledgeTestAnalysisDashboard, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.KnowledgeTestDashboard, component: KnowledgeTestDashboard, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.ConsumptionAnalysisDashboard, component: ConsumptionAnalysisDashboard, layout: Dashboard, exact: false, public: false },

    { path: RoutePaths.QuizSelection, component: QuizSelection, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.QuizExecute, component: QuizExecute, layout: Dashboard, exact: false, public: false },

    { path: RoutePaths.UserAdminList, component: UserAdminList, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.GroupAdminList, component: GroupAdminList, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.TopicAdminList, component: TopicAdminList, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.PublicationAdminList, component: PublicationAdminList, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.CourseAdminList, component: CourseAdminList, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.KnowledgeTestTopicList, component: KnowledgeTestTopicList, layout: Dashboard, exact: true, public: false },
    { path: RoutePaths.KnowledgeTestAdminList, component: KnowledgeTestAdminList, layout: Dashboard, exact: true, public: false },
    { path: RoutePaths.TopicFollowList, component: TopicFollowList, layout: Dashboard, exact: true, public: false },
    { path: RoutePaths.SetupMain, component: SetupMain, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.GamificationSetup, component: GamificationSetup, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.SystemLog, component: SystemLog, layout: Dashboard, exact: false, public: false },

    { path: RoutePaths.FullGlobalSearch, component: FullGlobalSearch, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.FullUserSearch, component: FullUserSearch, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.FullTopicSearch, component: FullTopicSearch, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.FullCourseSearch, component: FullCourseSearch, layout: Dashboard, exact: false, public: false },
    { path: RoutePaths.FullDocumentSearch, component: FullDocumentSearch, layout: Dashboard, exact: false, public: false },
];
